export const APPCONFIGACTION = {
  RESET_TOGGLE_MENU_BAR: "RESET_TOGGLE_MENU_BAR",
  TOGGLE_MENU_BAR: "TOGGLE_MENU_BAR",

  RESET_HOVER_MENU_BAR: "RESET_HOVER_MENU_BAR",
  TOGGLE_HOVER_MENU_BAR: "TOGGLE_HOVER_MENU_BAR",
};

// DEVICE TYPES
export const resetToggleMenuBar = () => ({
  type: APPCONFIGACTION.RESET_TOGGLE_MENU_BAR,
  data: undefined,
});

export const toggleMenubar = (data) => ({
  type: APPCONFIGACTION.TOGGLE_MENU_BAR,
  data,
});


export const resetHoverMenuBar = () => ({
  type: APPCONFIGACTION.RESET_HOVER_MENU_BAR,
  data: undefined,
}); 

export const toggleHoverMenubar = (data) => ({
  type: APPCONFIGACTION.TOGGLE_HOVER_MENU_BAR,
  data,
});